import PropTypes from 'prop-types';
import { Icon } from '@evertrue/et-components';
import { createBulkMessagesColumns } from './bulk-messages-columns';
import CadenceFlexTable from './cadence-flex-table';

const TOGGLEABLE = [
  'status',
  'cadenceShell',
  'channel',
  'createdBy',
  'createdDate',
  'lastUpdated',
  'recipients',
  'sendDate',
  'goalMetric',
  'deliveryRate',
  'bounceRate',
  'unsubscribeRate',
  'openRate',
  'clickRate',
  'replyRate',
  'tags',
];

const HIDDEN_COLUMNS = {
  cadenceShell: false,
  channel: false,
  createdDate: false,
  lastUpdated: false,
  deliveryRate: false,
  bounceRate: false,
  unsubscribeRate: false,
  openRate: false,
  clickRate: false,
  replyRate: false,
  tags: false,
};

const BulkMessagesTable = ({ data, loading, currentUserId, actions, renamingState, onSelectionChange }) => (
  <CadenceFlexTable
    tableKey="cadences-v2-bulk-messages"
    columns={createBulkMessagesColumns({ currentUserId, actions, renamingState })}
    data={data}
    loading={loading}
    onSelectionChange={onSelectionChange}
    toggleableColumns={TOGGLEABLE}
    columnVisibilityModel={HIDDEN_COLUMNS}
    emptyStateMessage="No Bulk Messages found"
    emptyStateIcon={<Icon icon="email" size={5} />}
  />
);

BulkMessagesTable.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  currentUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  actions: PropTypes.object,
  renamingState: PropTypes.object,
  onSelectionChange: PropTypes.func,
};

export default BulkMessagesTable;
